import { koComponent } from '../../../../ko-utils';
import $api from '../../../../api';
import constructTourCardsPerformance from './charts/tourCardsPerformance';
import constructTourGeneralPerformance from './charts/tourGeneralPerformance';

class TourPerformanceView {
    constructor(params) {
        this.isVisible = params.isVisible;
        this.isVisible.subscribe(val => {
            this.reinitIfVisible();
        });

        this.globalDateRange = params.globalDateRange;
        this.globalDateRange.subscribe(() => {
            this.reinitIfVisible();
        });

        this.tourId = params.tourId;

        this.conversionsChartState = ko.observable('loading');
        this.conversionsChartOptions = ko.observable({});
        this.generalChartState = ko.observable('loading');
        this.generalChartOptions = ko.observable({});

        this.tourIdSubscription = this.tourId.subscribe(() => {
            this.reinit();
        });

        this.reinitIfVisible();
    }

    get globalDateRangeUnwrapped() {
        return ko.unwrap(this.globalDateRange);
    }

    dispose() {
        this.tourIdSubscription.dispose();
    }

    reinitIfVisible() {
        if (ko.unwrap(this.isVisible)) {
            this.reinit();
        }
    }

    reinit() {
        this.conversionsChartState('loading');
        this.conversionsChartOptions({});
        this.loadConversionChart();

        this.generalChartState('loading');
        this.generalChartOptions({});
        this.loadGeneralChart();
    }

    loadGeneralChart() {
        $api.insights.getTourGeneralPerformance(
            {
                projectCode: auth.project.UniqueCode,
                id: ko.unwrap(this.tourId),
                from: this.globalDateRangeUnwrapped[0].toJSON(),
                to: this.globalDateRangeUnwrapped[1].toJSON()
            },
            {},
            (resp) => {
                var strDates = Object.keys(resp);

                var finished = [];
                var notFinished = [];
                var skipped = [];

                for (var key of strDates) {
                    finished.push(resp[key].finishedCount);
                    notFinished.push(resp[key].notFinishedCount);
                    skipped.push(resp[key].skippedCount);
                }

                if (finished.every(i => i === 0) && notFinished.every(i => i === 0) && skipped.every(i => i === 0)) {
                    this.generalChartState('empty');
                } else {
                    this.generalChartState('loaded');
                }

                var xAxisCategories = strDates.map(i => new Date(i).toJSON());

                this.generalChartOptions(constructTourGeneralPerformance(xAxisCategories, finished, notFinished, skipped));
            }
        );
    }

    loadConversionChart() {
        $api.insights.getTourCardsPerformance(
            {
                projectCode: auth.project.UniqueCode,
                id: ko.unwrap(this.tourId),
                from: this.globalDateRangeUnwrapped[0].toJSON(),
                to: this.globalDateRangeUnwrapped[1].toJSON()
            },
            {},
            (resp) => {
                if (!resp || resp.viewsByCards.length === 0) {
                    this.conversionsChartState('empty');

                    return;
                } else {
                    this.conversionsChartState('loaded');
                }

                var xAxisCategories = resp.viewsByCards.map((i, index) => i.name || 'Step #' + (index + 1));

                //document.dispatchEvent(new CustomEvent('cards_funnel_loaded', {
                //    detail: {
                //        xAxisCategories,
                //        views: resp.viewsByCards.map(i => i.views)
                //    }
                //}));

                constructTourCardsPerformance({
                    xAxisCategories,
                    views: resp.viewsByCards.map(i => i.views)
                });
                //this.conversionsChartOptions(constructTourCardsPerformance(xAxisCategories, resp.viewsByCards.map(i => i.views)));
            }
        );
    }
}

export default koComponent('tour-performance-view', TourPerformanceView);